// TODO(sleahy): This copied from the old codebase. Add translations.
export const USER_DEPARTMENTS = [
  'Customer Support',
  'HR/People',
  'IT',
  'Marketing',
  'Product/Engineering',
  'Operations',
  'Research',
  'Sales',
] as const;

export type UserDepartment = (typeof USER_DEPARTMENTS)[number];

export const USER_DEPARTMENTS_TRANSLATION_KEYS: Record<UserDepartment, string> =
  {
    'Customer Support': 'customerSupport',
    'HR/People': 'hr',
    IT: 'it',
    Marketing: 'marketing',
    'Product/Engineering': 'productEngineering',
    Operations: 'operations',
    Research: 'research',
    Sales: 'sales',
  } as const;

export const USER_ROLES = [
  'Senior Leader',
  'Manager',
  'Individual Contributor',
] as const;

export type UserRole = (typeof USER_ROLES)[number];

export const USER_ROLES_TRANSLATION_KEYS: Record<UserRole, string> = {
  'Senior Leader': 'seniorLeader',
  Manager: 'manager',
  'Individual Contributor': 'individualContributor',
} as const;
